import {BaseDataProviderAgent} from "./BaseDataProviderAgent";
import {ListOptions} from "../../../services/intf/ListOptions";
import {ListResult} from "../../../model/ListResult";
import {DataProvider} from "../../../services/intf/DataProvider";
import {ReadDataProvider} from "../../../services/intf/ReadDataProvider";
import {options} from "superagent";

export class BaseReadDataProvider<TItem, TListOptions extends ListOptions>
    implements ReadDataProvider<TItem, TListOptions> {
    baseUrl: string;
    keyProperty: string = "id";

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    getByID = (id: string): Promise<TItem> =>
        BaseDataProviderAgent.send<TItem>(
            'get',
            `${this.baseUrl}/${id}`).then((result) => {
            return this.mapModel(result);
        });

    listOptionsToPath(options: TListOptions) {
        const opts = options as any;
        return Object.keys(opts)
            .filter((key) => opts[key] && opts[key] != "")
            .map(key => `${key}=${encodeURI(opts[key])}`).join('&').toString();
        // let result = `page=${options.page}&limit=${options.limit}`;
        // if (options.search)
        //     result += `&search=${encodeURI(options.search)}`;
        // if (options.sort)
        //     result += `&sort=${encodeURI(options.sort)}`;
        // return result;
    }

    mapModel = (model: any) : TItem => { return model as any };

    list = (options: TListOptions): Promise<ListResult<TItem>> =>
        BaseDataProviderAgent.send<ListResult<TItem>>(
            'get',
            `${this.baseUrl}?${this.listOptionsToPath(options)}`)
            .then((result) => {
                result.items = result.items.map((x) => this.mapModel(x));
                return result;
            });

    applyFilter(options: TListOptions, filter: any): TListOptions {
        return {...options, page: 1, ...filter};
    }

}